import { useRouter } from '@application/utils';
import type { MtLayoutData } from '@presentation/components';
import { useMemo, useState } from 'react';
import { BREEDER_APPLICATIONS_ALERT_EXCLUDED_ROUTES } from './constants';
import type { UseBreederAlertBarParams } from './types';
import { useCurrentProfileStep } from '../../pages/MtBreederOnboardingPageController/api/useCurrentProfileStep';

export const useBreederAlertBar = (params: UseBreederAlertBarParams) => {
  const { currentAccountType } = params;

  const [showAlertBar, setShowAlertBar] = useState(true);

  const { translate, routeLocationDescriptor, infoFromCurrentPath } = useRouter();

  const { profileValidated, currentProfileProgress, profileLoading } = useCurrentProfileStep();

  const alertBar = useMemo((): MtLayoutData['alertBar'] => {
    if (!showAlertBar) return;
    if (currentAccountType === 'buyer') return;
    if (BREEDER_APPLICATIONS_ALERT_EXCLUDED_ROUTES.includes(infoFromCurrentPath.route)) return;
    if (currentProfileProgress === 2 || profileValidated || profileLoading) return;

    const link =
      currentProfileProgress > 2
        ? routeLocationDescriptor('mtLanding')
        : routeLocationDescriptor('mtOnboarding');
    return {
      title: translate('mt.breeder.onboarding.alertBar.title'),
      content: translate('mt.breeder.onboarding.alertBar.text'),
      linkText: translate('common.buttons.continue'),
      link,
      showProfileProgress: true,
      theme: 'warning',
    };
  }, [
    showAlertBar,
    currentAccountType,
    infoFromCurrentPath.route,
    currentProfileProgress,
    profileValidated,
    profileLoading,
    translate,
    routeLocationDescriptor,
  ]);

  return {
    alertBar,
  };
};
